import { Node_Type } from 'ricos-schema';

/**
 * Node types relevant for content truncate by node count.
 *
 */
export type Countable =
  | Node_Type.APP_EMBED
  | Node_Type.AUDIO
  | Node_Type.BUTTON
  | Node_Type.CODE_BLOCK
  | Node_Type.DIVIDER
  | Node_Type.EMBED
  | Node_Type.EXTERNAL
  | Node_Type.FILE
  | Node_Type.GALLERY
  | Node_Type.GIF
  | Node_Type.HEADING
  | Node_Type.HTML
  | Node_Type.IMAGE
  | Node_Type.LINK_PREVIEW
  | Node_Type.MAP
  | Node_Type.PARAGRAPH
  | Node_Type.POLL
  | Node_Type.VIDEO;

export const DEFAULT_COUNTABLE_TYPES = [
  Node_Type.APP_EMBED,
  Node_Type.AUDIO,
  Node_Type.BUTTON,
  Node_Type.CODE_BLOCK,
  Node_Type.DIVIDER,
  Node_Type.EMBED,
  Node_Type.EXTERNAL,
  Node_Type.FILE,
  Node_Type.GALLERY,
  Node_Type.GIF,
  Node_Type.HEADING,
  Node_Type.HTML,
  Node_Type.IMAGE,
  Node_Type.LINK_PREVIEW,
  Node_Type.MAP,
  Node_Type.PARAGRAPH,
  Node_Type.POLL,
  Node_Type.VIDEO,
] as Node_Type[];

/**
 * Node types relevant for content truncate by word count.
 *
 */
export type TextContainer = Node_Type.CODE_BLOCK | Node_Type.HEADING | Node_Type.PARAGRAPH;

export const isTextContainer = (type: Node_Type): type is TextContainer =>
  [Node_Type.CODE_BLOCK, Node_Type.HEADING, Node_Type.PARAGRAPH].includes(type);

/**
 * Node types relevant for the content truncate by maxPlugins
 *
 */
export type NonTextual =
  | Node_Type.APP_EMBED
  | Node_Type.AUDIO
  | Node_Type.BUTTON
  | Node_Type.DIVIDER
  | Node_Type.EMBED
  | Node_Type.EXTERNAL
  | Node_Type.FILE
  | Node_Type.GALLERY
  | Node_Type.GIF
  | Node_Type.HTML
  | Node_Type.IMAGE
  | Node_Type.LINK_PREVIEW
  | Node_Type.MAP
  | Node_Type.POLL
  | Node_Type.VIDEO;

export const isNonTextual = (type: Node_Type): type is NonTextual =>
  [
    Node_Type.APP_EMBED,
    Node_Type.AUDIO,
    Node_Type.BUTTON,
    Node_Type.DIVIDER,
    Node_Type.EMBED,
    Node_Type.EXTERNAL,
    Node_Type.FILE,
    Node_Type.GALLERY,
    Node_Type.GIF,
    Node_Type.HTML,
    Node_Type.IMAGE,
    Node_Type.LINK_PREVIEW,
    Node_Type.MAP,
    Node_Type.POLL,
    Node_Type.VIDEO,
  ].includes(type);
